import { memo } from "react";
import ChartCardContainer from "./Container";
import { ChartCardBaseProps } from "./Interfaces";

const ChartCard = (props: ChartCardBaseProps) => {
  return <ChartCardContainer {...props} />;
};

export default memo(ChartCard);
